/* eslint-disable camelcase */
import _ from 'lodash'
import saveTemplate from './save-template'
import getTemplateInfo from './get-template-info'
import resetTemplate from './reset-template'
import useIdToFindCategory from '@/views/creative/utils/use-id-to-find-category'
import previewTemplate from './preview'
import getTemplateOriginalInfo from './get-template-original-info'
import rebuildCategory from '../common/rebuild-category'
import publishCustom from './publish-custom'
import initBaseConfig from './init-base-config'
import { addGameDifficulty, removeGameDifficulty } from './game-difficulty'
import { addI18nLanguage, deleteI18nLanguage } from './i18n'
import generateGroupList from '@/views/creative/utils/generate-group-list'
import {
  addResource,
  removeResource,
  updateResource,
  changeDefaultResource,
  resetResource,
} from './resource'
import { language } from '@/common/storage'
import livePreview from './live-preview'
import livePreviewResources from './live-preview-resources'
import livePreviewJsonConfig from './live-preview-json-config'
import getQrcodePreviewUrl from './get-qrcode-preview-url'
import { workspaceSetting } from '@pt/utils/storage'
import saveTemplateInfo from './save-template-info'
import {
  findCatgeory,
  gameConfigCategoryResourceType,
  getCategoryRef,
  isFeGameConfigCategory,
  isPresetOptionCategory,
} from '@/store/creative/common/category'
import { dotNotationToBracketNotation } from '@com/utils/string'
import { syncCategoryToPresetConfig } from '@/views/creative/utils/preset-utils'
import { isPlayAgain } from '@/views/creative/utils'

export default {
  getTemplateInfo,
  previewTemplate,
  saveTemplate,
  resetTemplate,
  getTemplateOriginalInfo,
  publishCustom,
  initBaseConfig,
  getQrcodePreviewUrl,
  saveTemplateInfo,

  // 静态资源
  addResource,
  removeResource,
  updateResource,
  resetResource,
  changeDefaultResource,

  // 玩法
  addGameDifficulty,
  removeGameDifficulty,

  // 代码字
  addI18nLanguage,
  deleteI18nLanguage,

  // 实时预览
  livePreview,
  livePreviewResources,
  livePreviewJsonConfig,
  async navigateToStartScene({ dispatch }) {
    await dispatch('previewer/livePreview', {
      action: 'navigate',
      scene: 'start',
    })
  },

  /**
   * 更新目标分类
   * @param state
   * @param commit
   * @param newCategory {{id: string|number, properties: {visible: boolean, volume: number}, name: string}}
   */
  updateTargetCategory({ state, commit }, newCategory) {
    const updateTargetCategory = ({ templateCategory, newCategoryList }) => {
      // 深拷贝，保证不修改源数据
      newCategoryList = _.cloneDeep(newCategoryList)
      const traverse = (category) => {
        return category.map((item) => {
          if (newCategoryList[item.id]) {
            // 为啥要拷贝，因为如果存在重复资源，如果删除分类的名字字段，会让后面赋值不正常
            const categoryAttrs = _.cloneDeep(
              newCategoryList[item.id].categoryAttrs,
            )

            if (language.get() === 'en') {
              // 如果传参含有 name_en 字段，就使用 name_en 字段
              // 因为更新 desc 也会更新这里，需要判断是否有 name_en 和 name 字段
              if (
                typeof categoryAttrs.name_en !== 'undefined' ||
                typeof categoryAttrs.name !== 'undefined'
              ) {
                categoryAttrs.name_en =
                  typeof categoryAttrs.name_en !== 'undefined'
                    ? categoryAttrs.name_en
                    : categoryAttrs.name
                // 删除新分类中的名字，避免覆盖掉原有的
                delete categoryAttrs.name
              }
            }

            return {
              ...item,
              ...categoryAttrs,
              sub_category: Array.isArray(item.sub_category)
                ? traverse(item.sub_category)
                : null,
            }
          }

          return {
            ...item,
            sub_category: Array.isArray(item.sub_category)
              ? traverse(item.sub_category)
              : null,
          }
        })
      }

      return traverse(templateCategory)
    }

    // 增加直接修改分类英文名字的逻辑
    const categoryAttrs = _.pick(newCategory, [
      'name',
      'properties',
      'desc',
      'name_en',
      'desc_en',
      'options_en',
    ])
    const categoryId = Number(newCategory.id)
    const targetCategory = useIdToFindCategory({
      category: state.templateConfig.category,
      categoryId,
    })
    const categoryRef = getCategoryRef(
      targetCategory,
      state.templateConfig.category_ref,
    )

    const newCategoryList = {
      [categoryId]: {
        categoryAttrs,
      },
    }
    categoryRef &&
      categoryRef.forEach((item) => {
        newCategoryList[item] = {
          categoryAttrs,
        }
      })
    state.templateConfig.category = updateTargetCategory({
      templateCategory: state.templateConfig.category,
      newCategoryList,
    })
    // 更新玩法分类配置
    _.each(newCategoryList, (item, key) => {
      const cat = useIdToFindCategory({
        category: state.templateConfig.category,
        categoryId: Number(key),
      })
      if (cat.resource_type === gameConfigCategoryResourceType) {
        commit('updateTargetPlayConfig', {
          value: item.categoryAttrs,
          key: dotNotationToBracketNotation(cat.prefix),
        })
      }
    })
    commit('updateOutlineCategory')

    // 如果更新的是 presetOption 分类，需要同步到 presetConfig
    if (isPresetOptionCategory(targetCategory)) {
      syncCategoryToPresetConfig(
        useIdToFindCategory({
          category: state.templateConfig.category,
          categoryId,
        }),
        _.get(state, 'templateConfig.json_config.presetConfig'),
      )
    }
  },

  /**
   * rebuildCategory 重新生成分类信息
   */
  rebuildCategory({ state, commit }) {
    const { category, resource, json_config, play_config } =
      state.templateConfig
    // 可以找到前端生成的玩法分类，说明玩法已经被生成过
    const hasInitGameConfigCategory = !_.isEmpty(
      findCatgeory(
        {
          sub_category: category,
        },
        (cat) => {
          return isFeGameConfigCategory(cat)
        },
      ),
    )
    const hasInitPlayAgainCategory = !_.isEmpty(
      findCatgeory(
        {
          sub_category: category,
        },
        (cat) => {
          return isPlayAgain(cat.id)
        },
      ),
    )
    state.templateConfig.category = rebuildCategory({
      category,
      hasInitGameConfigCategory,
      resource,
      jsonConfig: json_config,
      page: state.page,
      commit,
      playConfig: play_config,
      starsConfig: state.starsConfig,
      gameDifficulty: state.gameDifficulty,
      isMultiCustom: state.isMultiCustom,
      gameConfigResource: _.cloneDeep(state.gameConfigResource),
      i18nResource: state.i18nResource,
      mwConfig: state.templateConfig.mw_config,
      supportedMwConfigs: state.templateConfig.supported_mw_configs,
      enableGameConfig: state.templateConfig.enable_gameconfig,
      permissionKeys: state.permissions,
      hasInitPlayAgainCategory,
    })
    commit('updateOutlineCategory')
  },

  updateTemplateInfo({ commit }, info) {
    commit('updateTemplateConfig', info)
  },

  updateWorkSpaceSetting({ commit, state }, setting) {
    if (setting) {
      state.workSpaceSetting = {
        ...state.workSpaceSetting,
        ...setting,
      }
      workspaceSetting.set(state.workSpaceSetting)
    }
  },

  autoSaveTemplate({ state, dispatch, commit }) {
    state.autoSaveTimeId = setInterval(async () => {
      try {
        commit('updateTemplateState', 'saving')
        await dispatch('saveTemplate', {
          autoSave: true,
        })
        commit('updateTemplateState', 'saved-successfully')
      } catch (e) {
        commit('updateTemplateState', 'editing')
      }
    }, 5000)
  },

  removeAutoSave({ state }) {
    clearInterval(state.autoSaveTimeId)
  },

  /**
   * updateGroupsConfig
   * @param state
   * @param [value] {{}}
   */
  updateGroupsConfig({ state, commit, dispatch }, value) {
    if (Array.isArray(value)) {
      state.groupsConfig = value
    } else {
      state.groupsConfig = generateGroupList({
        resource: state.templateConfig.resource,
        i18nResource: state.i18nResource,
        gameConfigResource: state.gameConfigResource,
        templateConfig: state.templateConfig,
        state,
      })
    }
    // 更新完 groupsConfig 要更新当前预览组合的配置
    commit('updatePreviewGroupConfig')
  },

  /**
   * 更新全局跳转、诱导点击、自动跳转关联配置
   * @param switchName {string} global_click、auto_click、yd_click
   */
  updateRefGameConfig({ commit, state }, switchName) {
    const gameConfigResource = state.gameConfigResource
    const originalJsonConfig = state.originalJson

    const rec = (config) => {
      _.each(config, (item, key) => {
        if (item[_.camelCase(switchName)]) {
          if (_.get(originalJsonConfig, item.mw_mapping_path)) {
            console.log(
              `originalJson 找到${item.mw_mapping_path}`,
              _.get(originalJsonConfig, item.mw_mapping_path),
            )
            // 数组更新特殊处理
            if (_.isArray(config)) {
              config.splice(key, 1, {
                ...config[key],
                value: _.get(
                  originalJsonConfig,
                  `${item.mw_mapping_path}.value`,
                ),
              })
            } else {
              config[key] = {
                ...config[key],
                value: _.get(
                  originalJsonConfig,
                  `${item.mw_mapping_path}.value`,
                ),
              }
            }
          } else {
            console.log(`originalJson 找不到${item.mw_mapping_path}`)
          }
        }
        if (_.isPlainObject(item) || _.isArray(item)) {
          rec(item)
        }
      })
    }

    if (gameConfigResource) {
      rec(gameConfigResource)
      commit('updateGameConfigResource', gameConfigResource)
    }
  },

  /**
   * 更新对应语言全部文案的字体样式
   * updateTargetLanguageAll18nResource
   * @param state {}
   * @param style {style: {}}
   * @param language {string}
   */
  updateTargetLanguageAll18nResource(
    { state, commit, dispatch },
    { style, language },
  ) {
    const i18nResource = state.i18nResource
    for (const key in i18nResource) {
      const refResource = i18nResource[key]
      _.each(refResource, (resourceItem, resourceIndex) => {
        commit('updateTargetI18nResource', {
          key,
          index: resourceIndex,
          language,
          value: {
            style: {
              ...resourceItem.data[language].style,
              font: style.font,
            },
          },
        })
      })
    }

    // 未关联场景文案处理
    const localLanguages = _.cloneDeep(
      state.templateConfig.json_config.i18n.languages[language],
    )
    const i18nResourceKeys = Object.keys(i18nResource)
    for (const key in localLanguages) {
      if (!i18nResourceKeys.includes(key)) {
        commit('updateNotSceneI18nResource', {
          key: key,
          language: language,
          value: {
            style: {
              ...localLanguages[key].style,
              font: style.font,
            },
          },
        })
      }
    }
  },
}
